/**
 * Deterministic per-lesson, per-day FSRS review idempotency key.
 *
 * The review endpoint dedups on (user_id, concept_id, attempt_id) with a 24h
 * TTL and, on a duplicate, returns the prior result WITHOUT re-applying the
 * grade. So if the lesson quiz and flashcards submit a concept's review with
 * the SAME token, whichever lands first wins and the other is a no-op — and a
 * same-day retry re-uses the token, so it never re-grades. A new day yields a
 * new token (a legitimate spaced re-review).
 */

/** `YYYYMMDD` in the user's LOCAL time (matches their perceived "day"). */
export function localDayKey(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}${m}${day}`;
}

/** Shared FSRS attempt_id for a lesson's quiz + flashcards on a given day.
 *  The dedup tuple already includes concept_id, so distinct concepts each
 *  apply once even though they share this token. */
export function practiceFsrsAttemptId(
  lessonId: string,
  day: string = localDayKey()
): string {
  return `practice:${lessonId}:${day}`;
}
